import Global from "../config/config.json";
import httpService from "../config/httpService";
const gameAPI= {

    async getAnswer(gid,jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}game-one/answer/${gid}`,{}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                        
                }
            })
        return res;
    },
    async getAnswer2(gid,jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}game-two/answer/${gid}`,{}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                        
                }
            })
        return res;
    },
    async verify(code,jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}game-one/verify`,{code:code}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                }
            })
        return res;
    },
    async sendCode(code,jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}profile/code`,{code:code}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                }
            })
        return res;
    },
    async help(type,jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}game-one/help`,{type:type}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
     
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                }
            })
        return res;
    },
    async select(type,guid,jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}game-one/help/select`,{type:type,guid:guid}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
       
                switch (json.status) {
                    case 200:
                        res = json.data
                        break;
                }
            })
        return res;
    },
}
export default gameAPI;